import _ from 'lodash';

const transformEntityTypeSelector = selector => (state, { entityType }) => selector(state, entityType);
export default selectors => _.map(selectors, transformEntityTypeSelector);